<template>
    <div class="box-form-check">
        <div class="container">
            <div class="row">
                <div class="box-form-check-header col-md-12">
                    <div class="box-absolute">
                        <div class="box-logo">
                            <img :src="igmLogo"/>
                        </div>
                        <div class="border-box"></div>
                        <div class="box-check-body">
                            <div class="title" v-html="formTitle"></div>
                            <p class="description" v-html="formDescription"></p>
                            <div class="p-field form-input">
                              <div class="box_note_check" v-if="screen == 'check'" >
                                <div class="col-md-12 row box_content_note">
                                  <div class="box_left_note"><div class="group_note_check" ><img class="img_note" :src="icon_check"><span class="text_note" >{{ noteMonitor }}</span></div></div>
                                  <div><div class="group_note_check" ><img class="img_note" :src="icon_check"><span class="text_note">{{noteCheck}}</span></div></div>
                                </div>
                              </div>
                                <div class="form-input-group">
                                    <div class="p-inputgroup">
                                        <InputText  maxlength="10" autocomplete="off" :placeholder="formPlaceholder" id="keyword" type="text" v-model="keyword" />
                                        <Button id="submitCheck" :class="keyword != '' && keyword.trim().length > 9 ? 'active' : ''" :label="formSubmit" @click="checkSerialNumber"/>
                                    </div>
                                </div>
                                <label v-if="message" class="error box-error">{{ message }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DataServices from '@/core/DataServices'
    export default {
        props: {
            lstData: Array,
            screen: {
              type: String,
              default: ''
            },
        },
        data() {
            return {
                igmLogo: window.origin + '/assets/images/logo_h_ng_k_.png',
                icon_check: window.origin + '/assets/images/double_check.png',
                formTitle: '',
                formPlaceholder: '',
                formDescription: '',
                formSubmit: '',
                keyword: '',
                message: '',
                noteMonitor: '',//ghi chú theo dõi
                noteCheck: '',//ghi chú kiểm tra
            }
        },
        mounted () {
            if (this.lstData != undefined && this.lstData && Object.keys(this.lstData).length > 0) {
                var objTitle = this.lstData.filter(a => a.key == 'PAGE_CHECKER_TITLE');
                if (objTitle && Object.keys(objTitle).length) {
                    this.formTitle = objTitle[0].value.trim();
                }

                var objPlaceholder = this.lstData.filter(a => a.key == 'PAGE_CHECKER_PLACEHOLDER');
                if (objPlaceholder && Object.keys(objPlaceholder).length) {
                    this.formPlaceholder = objPlaceholder[0].value.trim();
                }
                var objDescription = this.lstData.filter(a => a.key == 'PAGE_CHECKER_DESCRIPTION');
                if (objDescription && Object.keys(objDescription).length) {
                    this.formDescription = objDescription[0].value.trim();
                }
                var objFormSubmit = this.lstData.filter(a => a.key == 'PAGE_CHECKER_SUBMIT');
                if (objFormSubmit && Object.keys(objFormSubmit).length) {
                    this.formSubmit = objFormSubmit[0].value.trim();
                }
                var objNoteMonitor = this.lstData.filter(a => a.key == 'PAGE_CHECKER_NOTE_MONITOR');
                if (objNoteMonitor && Object.keys(objNoteMonitor).length) {
                  this.noteMonitor = objNoteMonitor[0].value.trim();
                }
                var objNoteCheck = this.lstData.filter(a => a.key == 'PAGE_CHECKER_NOTE_CHECK');
                if (objNoteCheck && Object.keys(objNoteCheck).length) {
                  this.noteCheck = objNoteCheck[0].value.trim();
                }
            }
            this.enterClickSumit();
        },
        methods: {
            checkInput () {
                var regex = /([a-zA-Z0-9]){10}/g
                return regex.test(this.keyword);
            },
            async checkSerialNumber() {
                this.keyword = this.keyword.trim();
                if (this.keyword.length == 10) {
                    var regex = this.checkInput();
                    if(!regex) {
                        this.message = "* Serial number không đúng. Vui lòng thử lại";
                    } else {
                        var key_word_convert = this.keyword.toUpperCase();
                        var variables1 = {
                            where_key: {
                                serial_number: {'_eq': key_word_convert },
                                production_status: {'_eq': 1},
                                status: {'_eq': 1}
                            }
                        }
                        var data1 = await DataServices.getList('product_serial_number', {"variables": JSON.stringify(variables1)});/*, "fields": "id"*/
                        var list1 = data1[Object.keys(data1)];
                        if (list1 && list1.length == 0) this.message = "* Serial number không đúng. Vui lòng thử lại";
                        else {
                            var warranty_status = this.res_warranty_status(list1[0]);
                            if (warranty_status == 6){
                              //Nếu là trạng thái hủy
                              this.message = "* Serial number không đúng. Vui lòng thử lại";
                            }else {
                              window.location.href = window.origin + '/check-warranty-detail/' + key_word_convert;
                            }
                        }
                    }
                }
            },
          res_warranty_status(data) {
            //Copy ProductSerialNumberModel warrantyStatus
            var warranty = -1;
            if (data.product_serial_number_info != undefined && data.product_serial_number_info != null && Object.keys(data.product_serial_number_info).length) {
              warranty = (data.product_serial_number_info.warranty_status != undefined && data.product_serial_number_info.warranty_status != null) ? Number(data.product_serial_number_info.warranty_status) : -1;
            }
            if (warranty == -1) warranty = (data.warranty_status != undefined && data.warranty_status != null) ?  Number(data.warranty_status) : -1;
            if (warranty != -1) {
              //data.warrantyStatus = (warranty == 5 ? 0 : warranty);
              warranty = (warranty == 5 ? 0 : warranty);
            }
            return warranty;
          },
          enterClickSumit() {
              var input = document.getElementById('keyword');
              input.addEventListener("keyup", function(event) {
                  if (event.keyCode === 13) {
                      event.preventDefault();
                      document.getElementById("submitCheck").click();
                  }
              });
          }
        },
    }
</script>

<style lang="scss">
.box-form-check{ margin: 0 auto; color: #1c1c1e; margin-top:  112.50px; 
    .box-form-check-header{text-align: center; padding: 0; position: relative;
        .box-absolute{ position: absolute; left: 0;   right: 0;  margin-left: auto;  margin-right: auto;
            .box-logo{margin: 0 auto; width: 111.7px; height: 93.83px; 
                img{width: 100%; height: 100%;}
            }
            .border-box{border-bottom: 4px solid #f00; margin-top: 60px; width: 103.50px; margin-left: auto; margin-right: auto;
              @media (max-width: 991px) {
                width: 80px;
              }
            }
            .title {margin-top: 24px;  font-weight: normal; font-size: 48px;font-family: 'Roboto'; line-height: 54px;
                span{font-weight: 900;}
            }
            // .description { font-size: 7.65pt; color: #636366; font-family: 'Roboto';}
            .form-input {width: 555px;margin-left: auto; margin-right: auto;
                .form-input-group { margin-top: 24px; background: #fff;  height: 64px; border-radius: 10px; border: 1px solid #26A2D6; overflow: hidden; display: flex;
                    .p-inputgroup{align-items: center;
                        .p-inputtext{border-radius: inherit; border: 0 none; padding-left: 17.94px; font-size: 20px; line-height: 22px;
                            &:enabled:focus{box-shadow: none;}
                            &:focus, &:visited, &:hover, &:active{outline: none;}
                            &::-webkit-input-placeholder {  color: #c7c7cc;}
                            &:-ms-input-placeholder {  color: #c7c7cc;}
                            &::placeholder{  color: #c7c7cc;}
                        }
                        button{ background: #c7c7cc; font-size: 15px; line-height: 22px; margin: 5.25px; width: 117px; height: 50px; border: 0 none; border-radius: 8px;  text-transform: uppercase;
                            &.active{background: #2196F3; border: 1px solid #2196F3;}
                        }
                    }
                }
                .box-error{margin-top: 12px; text-align: left; width: 100%; margin-bottom: 0;}
            }
        }
    }
}
@media screen  and (max-width: 991px){
    .box-form-check{padding: 0 5px !important;
        .box-form-check-header{
            .box-absolute{
                .title{font-size: 30px; line-height: 54px;}
                .form-input-group {
                    .p-inputgroup{
                        .p-inputtext{font-size: 14px !important;line-height: 22px;}
                        button{font-size: 12px !important;line-height: 14px !important; width: 104px; height: 42px;}
                    }
                }
            }
        }
    }
}
.box_note_check{
  margin-top: 24px;
  @media (max-width: 991px) {
    display: inline-flex;
  }
  @media (max-width: 505px) {
    margin-top: 0px;
  }
  .box_content_note{
    padding:0px 44px; margin-left: 0px; margin-right: 0px;
    @media (max-width: 991px) {
      padding:0px;
    }
    @media (max-width: 505px) {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .box_left_note{
      margin-right: 8px;
      @media (max-width: 505px) {
        margin-bottom: 16px;
      }
    }
    .group_note_check{
      padding: 8px 14px 8px 40px;height: 34px;background: #F5F5F7; border: 1px solid #F1F1F7; box-sizing: border-box; border-radius: 40px;position: relative;
      .img_note{
        width: 16.8px;height: 9.5px;position: absolute;left: 14.5px;margin: auto;top: 0px;bottom: 0px;
      }
      .text_note{
        font-weight: 500; font-size: 14px; line-height: 18px;color: #636366;
      }
    }
  }
}
</style>